export function isInternalPlaceholder(value) {
  return typeof value === "string" && value.startsWith("Pending_");
}

export function getRecordBusinessName(record) {
  const raw = record?.businessName ?? record?.business_name ?? "";
  if (!raw || isInternalPlaceholder(raw)) return "";
  return String(raw);
}

export function getRecordBusinessNumber(record) {
  const raw =
    record?.businessNumber ??
    record?.business_number ??
    record?.contactPersonNumber ??
    record?.contactPersonnumber ??
    record?.contact_number ??
    "";
  if (!raw || isInternalPlaceholder(raw)) return "";
  return String(raw);
}

export function hasUserAccount(record) {
  const hasLinkedUser = Boolean(record?.userId || record?.user?._id || record?.user);
  if (hasLinkedUser) return true;

  // Some signed-up merchants are returned without `user` relation hydrated yet.
  // Treat onboarding-started and already-live merchant statuses as merchant records (not invites).
  const status = normalizeStatus(record?.status);
  return ["approved", "live", "in-progress", "accepted", "completed"].includes(status);
}

export function normalizeStatus(value) {
  return String(value || "")
    .trim()
    .toLowerCase()
    .replace(/\s+/g, "-")
    .replace(/_/g, "-");
}

export function formatAuPhoneLoose(number) {
  if (!number) return "";
  const digits = String(number).replace(/\D/g, "");
  const cleaned = digits.startsWith("61") ? digits.slice(2) : digits;
  if (cleaned.length === 9) return `${cleaned.slice(0, 3)} ${cleaned.slice(3, 6)} ${cleaned.slice(6)}`;
  if (cleaned.length === 10) return `${cleaned.slice(0, 4)} ${cleaned.slice(4, 7)} ${cleaned.slice(7)}`;
  return String(number);
}

